export default "/images/598c40fd070f81515353d326903e319b.avif";